import { Reveal } from '@/components/primitives'

/**
 * Scale proof band. Big commercial flex under the hero.
 */
export function ScaleFlex() {
  return (
    <section
      aria-label="Scale and volume"
      className="border-b border-base-line bg-base-900/60"
    >
      <div className="mx-auto w-full max-w-7xl px-5 py-14 sm:px-8 md:py-20">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <p className="mono-label">Scale that is already proven</p>
            <h2 className="mt-3 text-2xl font-extrabold tracking-tight text-ink sm:text-3xl md:text-4xl">
              Built for volume. Already running it.
            </h2>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="mx-auto mt-10 max-w-5xl border border-base-line bg-base-850 p-6 text-center sm:p-8 md:mt-12 md:p-10">
            <p className="font-display text-[clamp(3.5rem,12vw,8rem)] font-semibold leading-none tracking-[-0.03em] text-signal">
              145M+
            </p>
            <p className="mt-4 text-lg font-extrabold tracking-tight text-ink sm:text-xl md:text-2xl">
              policies processed on the TLD stack
            </p>
            <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-ink-mute md:text-base">
              Other platforms brag about a million enrollments. We are already past one hundred
              forty-five million policies. That is the difference between a tool and an operating
              system.
            </p>

            <ul className="mx-auto mt-10 grid max-w-4xl gap-6 text-center sm:grid-cols-3 sm:gap-4">
              <li className="border-t border-signal/40 pt-4 sm:border-l sm:border-t-0 sm:px-4 sm:pt-0">
                <p className="text-sm font-extrabold text-ink">Real production volume</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-mute">
                  Not a pilot. Not a demo sandbox. Throughput the stack already carries.
                </p>
              </li>
              <li className="border-t border-signal/40 pt-4 sm:border-l sm:border-t-0 sm:px-4 sm:pt-0">
                <p className="text-sm font-extrabold text-ink">One operating model</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-mute">
                  Records, routing, conversations, and outcomes on the same system.
                </p>
              </li>
              <li className="border-t border-signal/40 pt-4 sm:border-l sm:border-t-0 sm:px-4 sm:pt-0">
                <p className="text-sm font-extrabold text-ink">See it on your operation</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-mute">
                  Book a walkthrough. We map TLDNXS on your sources, queues, and handoffs.
                </p>
              </li>
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
